import Reveal from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "The Noise",
    body:
      "Starting is the hardest part. Endless conflicting advice, intimidating machines, and no clear direction. Most people quit before they ever build any real momentum.",
  },
  {
    n: "02",
    title: "The Foundations",
    body:
      "This boot camp is built to teach the foundational principles of movement and strength — done properly, so your base actually holds. As you master them, you build momentum that pushes you closer to your goal.",
  },
  {
    n: "03",
    title: "The Recovery",
    body:
      "The 15 sessions are deliberately non-consecutive. Rest days are where progress is made — so the schedule is spaced out to protect your recovery and keep you moving without injury.",
  },
];

export default function Empathy() {
  return (
    <section
      data-testid="empathy-section"
      className="relative py-28 sm:py-40 px-5 sm:px-8"
    >
      <div className="max-w-[1400px] mx-auto">
        <Reveal>
          <p className="text-xs tracking-[0.3em] uppercase font-bold text-[#d4af37] mb-16">
            Why This Works
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-16 lg:gap-28">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.15}>
              <div className="border-t border-white/10 pt-8">
                <div className="flex items-baseline gap-5 mb-6">
                  <span className="font-display font-black text-5xl sm:text-6xl text-[#d4af37]/30">
                    {c.n}
                  </span>
                  <span className="text-neutral-500 text-sm">/</span>
                  <h2 className="font-display font-bold uppercase tracking-tight text-3xl sm:text-4xl">
                    {c.title}
                  </h2>
                </div>
                <p className="text-lg font-light text-neutral-300 leading-relaxed max-w-md">
                  {c.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
